import React from "react";
import CommonButton from "../../../components/buttons/CommonButton";
import PropTypes from "prop-types";
import CommonModal from "../../../components/Common/CommonModal";
import CommonInputFile from "../../../components/forms/CommonInputFile";
import { handleChangeFile } from "../../../helpers/handleFormChanges";
import ErrorSwal from "../../../components/Swal/errorSwal";

function DocumentosUploadModal({
  modalHook,
  valuesHook,
  uploadDocumento,
  tipo,
  substituirDocumento,
  substituir,
}) {
  const { uploadArquivoModal, setUploadArquivoModal } = modalHook;
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title={substituir ? "Substituir documento" : "Upload"}
      is_open_modal={uploadArquivoModal}
      set_is_open_modal={setUploadArquivoModal}
      size="md"
      buttons={
        <CommonButton
          key={`upload-arquivo`}
          color="success"
          onClick={() => {
            if (substituir) substituirDocumento();
            else uploadDocumento();
          }}
        >
          Enviar
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-12 mb-3">
          <CommonInputFile
            id="arquivo"
            label={tipo === 1 ? "Extrato Bancário" : "Notas Fiscais"}
            onChange={(e) => {
              if (e.target.files && e.target.files[0]) {
                const file = e.target.files[0];
                const accept = tipo === 1 ? ".pdf" : ".zip, .rar";
                const allowedTypes = accept.replace(/\s/g, "").split(",");
                const fileExt = file.name
                  .substring(file.name.lastIndexOf("."))
                  .toLowerCase();
                if (!allowedTypes.includes(fileExt)) {
                  ErrorSwal({
                    text: `Tipo de arquivo inválido.`,
                  });
                  e.target.value = "";
                  return;
                }
              }
              handleChangeFile(e, values, setValues);
            }}
            accept={tipo === 1 ? ".pdf" : ".zip, .rar"}
          />
        </div>
      </div>
    </CommonModal>
  );
}

DocumentosUploadModal.propTypes = {
  modalHook: PropTypes.shape({
    uploadArquivoModal: PropTypes.bool.isRequired,
    setUploadArquivoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  uploadDocumento: PropTypes.func.isRequired,
  tipo: PropTypes.number.isRequired,
  substituirDocumento: PropTypes.func.isRequired,
  substituir: PropTypes.bool.isRequired,
};

export default DocumentosUploadModal;
